// GET /api/v1/public/:roleId/purchase-orders/ankitpopli@codemymobile.com
// POST /api/v1/public/:roleId/purchase-orders/ankitpopli@codemymobile.com

export const getPurchaseOrders = (roleId, email, statusFilter) => {
    let body = {};
    if (statusFilter && statusFilter !== 'all') {
        body.status = statusFilter;
    }
    let fetchUrl = `${process.env.REACT_APP_API_URL}/api/v1/public/${roleId}/purchase-orders/${email}`;
    if (Object.keys(body)) {
        fetchUrl += '?' + Object.keys(body).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(body[k])}`).join('&');
    }
    return fetch(fetchUrl)
        .then(resp => resp.json())
        .then(resp => {
            if (resp.success) {
                return {requests: resp.results, counts: resp.counts};
            }
            throw resp.message;
        });
};

export const createPurchaseOrder = (roleId, { requesterEmail: email, ...data }) => {
    data.vendor = data.vendor
        ? data.vendor.id : undefined;

    return fetch(`${process.env.REACT_APP_API_URL}/api/v1/public/${roleId}/purchase-orders/${email}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...data,
        })
    })
        .then(resp => resp.json())
        .then(resp => {
            if (resp.success) {
                return resp.result;
            }
            throw resp.message;
        });
};

export const addPurchaseOrderUpdate = (roleId, email, id, text) =>
    fetch(`${process.env.REACT_APP_API_URL}/api/v1/public/${roleId}/purchase-orders/${email}/${id}/update`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            role: roleId,
            email,
            text,
            id,
        })
    })
        .then(resp => resp.json())
        .then(resp => resp.result)
        .then(po => po.updates)
        .catch(console.error);


export const generatePDF = (role, order) => {

    if(!order){
        return;
    }
    var data = {};
    const { currencyDictionary } = role;
    const currencySymbol = currencyDictionary ?
        currencyDictionary.symbol : '$';

    var vendor = order.vendor;
    data.roleId = role.objectId;
    data.companyName = order.companyName;
    data.street = order.companyStreet;
    data.city = order.companyCity;
    data.state = order.companyState;
    data.zip = order.companyZip;
    data.phone = order.companyPhone;
    data.fax = order.companyFax;
    data.poNo = order.purchaseOrderNumber;
    data.objectId = order.objectId;
    if (order.vendor) {
        data.toName = vendor.contact;
        data.toCompany = vendor.name;
        data.toStreet = vendor.street;
        data.toCity = "";
        data.toState = "";
        data.toZip = "";
        data.toPhone = vendor.phone;
    }

    data.shipToName = order.shippingName;
    data.shipToCompany = order.shippingCompany;
    data.shipToStreet = order.shippingStreet;
    data.shipToCity = order.shippingCity;
    data.shipToState = order.shippingState;
    data.shipToZip = order.shippingZip;
    data.shipToPhone = order.shippingPhone;
    data.notes = order.description;
    data.poDate = order.dueDate;
    data.requisitioner = order.requisitioner;
    data.shippedVia = order.shippingMethod;
    data.fobPoint = order.fobPoint;
    data.terms = order.terms;
    data.subtotal = currencySymbol + (order.subtotal || '0');
    data.salesTax = currencySymbol + order.tax;
    data.shippingAndHandling = currencySymbol + order.shippingCost;
    data.other = currencySymbol + order.otherCost;
    data.grandTotal = currencySymbol + (order.totalCost || '0');
    data.excludeUpkeepLogo = order.hideUpkeepLogo;
    if(order.showCompanyLogo === true || order.showCompanyLogo === false) {
      data.showCompanyLogo = order.showCompanyLogo;
    }
    if(order.companyLogo) {
      data.companyLogo = order.companyLogo.url;
    }

    if (order.parts) {
        var parts = order.parts.map(function(part) {
            return {
                qty: part.numberPartQuantity,
                unit: part.stringPartName,
                description: part.stringPartDescription,
                unitPrice: currencySymbol + part.stringPartCost,
                total: currencySymbol + (+part.numberPartQuantity*+part.numberPartCost).toFixed(2)
            };
        });
        data.items = parts;
    }

    return fetch(`${process.env.REACT_APP_API_URL}/api/purchase-order`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
    .then(response => response.blob())
    .then(blob => {
            var file = new Blob([blob], {type: 'application/pdf'});
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
    })
    .catch(console.error);
};
